"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = exports.createModalData = void 0;
var _createModalData = require("./createModalData/createModalData");
exports.createModalData = _createModalData.createModalData;
var _shouldOpenPreferencesModal = require("./shouldOpenPreferencesModal/shouldOpenPreferencesModal");
exports.shouldOpenPreferencesModal = _shouldOpenPreferencesModal.shouldOpenPreferencesModal;
//# sourceMappingURL=index.js.map